import { IMAGE_DIR } from '@/shared/constants/linksApi'
import Link from 'next/link'

export const BlogItem = ({
    title,
    text,
    image,
    itemClass,
    itemId,
    itemUrl,
}) => {
    return (
        <Link
            href={`/${itemUrl}`}
            // target="_blank"
            className={`item-blog ${itemClass}`}
        >
            <div className={'content-item'}>
                <h3>{title}</h3>
                <p>{text}</p>
            </div>
            <div className={'background-container'}>
                <div className={'gradient'}></div>
                <img src={`${IMAGE_DIR}${image}`} alt="" />
            </div>
        </Link>
    )
}
